import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 481440 693966"
    {...props}
  >
    <path
      d="M240705 684986 4150 331643l209746 156647V5000h53638v483290l209756-156647z"
      style={{
        fill: "#2b2a29",
        stroke: "#1c1b17",
        strokeWidth: 9999.79,
      }}
      className="fill stroke1"
    />
  </svg>
)
export default SvgComponent
